var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.322,46.184c0.095-0.671,0.143-1.35,0.143-2.033c0-7.949-6.467-14.416-14.416-14.416 c-7.106,0-13.028,5.168-14.204,11.943c-1.042-0.276-2.121-0.417-3.206-0.417c-6.894,0-12.502,5.608-12.502,12.502 c0,6.894,5.608,12.502,12.502,12.502h29.003c5.636,0,10.221-4.585,10.221-10.22C73.863,51.312,70.698,47.353,66.322,46.184z  M63.643,62.265H34.639c-4.688,0-8.502-3.813-8.502-8.502s3.814-8.502,8.502-8.502c1.417,0,2.82,0.355,4.057,1.028 c0.629,0.342,1.395,0.323,2.004-0.053c0.61-0.375,0.973-1.049,0.951-1.765l-0.019-0.32c0-5.744,4.673-10.416,10.417-10.416 c5.743,0,10.416,4.672,10.416,10.416c0,1.055-0.157,2.096-0.467,3.095c-0.185,0.596-0.081,1.245,0.281,1.753 s0.941,0.819,1.565,0.838c3.375,0.107,6.019,2.835,6.019,6.208C69.863,59.475,67.072,62.265,63.643,62.265z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.1ad7e3f9540b211c9eba707205412cf2.svg";
export { ForwardRef as ReactComponent };